import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Landing from '@/views/Landing.vue'

const Home = () => import('@/views/Home.vue')
const Folders = () => import('@/views/Folders.vue')
const Albums = () => import('@/views/Albums.vue')
const Tags = () => import('@/views/Tags.vue')
const TagDetail = () => import('@/views/TagDetail.vue')
const Genres = () => import('@/views/Genres.vue')
const GenreDetail = () => import('@/views/GenreDetail.vue')
const Artists = () => import('@/views/Artists.vue')
const ArtistDetail = () => import('@/views/ArtistDetail.vue')
const FolderDetail = () => import('@/views/FolderDetail.vue')
const AlbumDetail = () => import('@/views/AlbumDetail.vue')
const VinylShelf = () => import('@/views/VinylShelf.vue')

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/folders',
    name: 'Folders',
    component: Folders,
    meta: { requiresAuth: true }
  },
  {
    path: '/folders/:id',
    name: 'FolderDetail',
    component: FolderDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/vinyl-shelf',
    name: 'VinylShelf',
    component: VinylShelf,
    meta: { requiresAuth: true }
  },
  {
    path: '/albums',
    name: 'Albums',
    component: Albums,
    meta: { requiresAuth: true }
  },
  {
    path: '/albums/:id',
    name: 'AlbumDetail',
    component: AlbumDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
    meta: { requiresAuth: true }
  },
  {
    path: '/tags/:name',
    name: 'TagDetail',
    component: TagDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/genres',
    name: 'Genres',
    component: Genres,
    meta: { requiresAuth: true }
  },
  {
    path: '/genres/:name',
    name: 'GenreDetail',
    component: GenreDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/artists',
    name: 'Artists',
    component: Artists,
    meta: { requiresAuth: true }
  },
  {
    path: '/artists/:name',
    name: 'ArtistDetail',
    component: ArtistDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/views/Maintenance.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/auth/success',
    name: 'AuthSuccess',
    redirect: '/dashboard',
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Redirect unauthenticated users to landing page
    next('/')
  } else if (authStore.isAuthenticated && to.path === '/') {
    // Redirect authenticated users from landing to dashboard
    next('/dashboard')
  } else {
    next()
  }
})

export default router
